function getCoachingScoreRange(gradingValueType) {
  return gradingValueType === "yes_no" ? [0, 1] : [1, 5];
}
function normalizeCriterionScore(score, gradingValueType) {
  const [minimum, maximum] = getCoachingScoreRange(gradingValueType);
  return (score - minimum) / (maximum - minimum) * 100;
}
function formatCoachingScore(value, gradingValueType) {
  if (gradingValueType === "yes_no") {
    return value.toLocaleString("en-US", {
      style: "percent",
      maximumFractionDigits: 0
    });
  }
  return value.toLocaleString("en-US", {
    style: "decimal",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
}
export {
  formatCoachingScore,
  getCoachingScoreRange,
  normalizeCriterionScore
};
//# sourceMappingURL=coachingScore.js.map
